import { Card } from 'antd';
import { colors, radius } from 'design';
import { createUseStyles } from 'react-jss';

export const MODULE_CARD_ACCENT_GRADIENT = colors.gradient.primary.value;

export type ModuleCardProps = {
  title?: React.ReactNode;
  topRightContent?: React.ReactNode;
  children: React.ReactNode;
  block?: boolean;
  centerTitle?: boolean;
  coverImage?: string;
  /**
   * Renders the card on the brand accent gradient.
   *
   * The gradient is light, so content inside must use `colors.brand.onAccent`
   * for text and icons — white does not survive on it.
   */
  accentBackground?: boolean;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  role?: string;
  tabIndex?: number;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
};

const useStyles = createUseStyles({
  moduleCard: {
    border: 'none',
    borderRadius: radius.xl,
  },
  moduleCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  moduleCardHeaderCentered: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  cardTitle: {
    margin: 0,
    color: colors.text.secondary,
  },
});

const ModuleCard: React.FC<ModuleCardProps> = ({
  title,
  topRightContent,
  children,
  block = true,
  centerTitle = false,
  coverImage,
  accentBackground = false,
  style,
  bodyStyle,
  onClick,
  role,
  tabIndex,
  onKeyDown,
}) => {
  const styles = useStyles();

  const accentStyle: React.CSSProperties = accentBackground ? { background: MODULE_CARD_ACCENT_GRADIENT } : {};
  const accentBodyStyle: React.CSSProperties = accentBackground ? { background: 'transparent' } : {};

  return (
    <Card
      className={styles.moduleCard}
      style={{ width: block ? '100%' : 'fit-content', ...accentStyle, ...style }}
      styles={{
        body: { ...accentBodyStyle, ...(bodyStyle ?? {}) },
      }}
      cover={coverImage ? <img src={coverImage} /> : undefined}
      onClick={onClick}
      role={role}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
    >
      <div className={centerTitle ? styles.moduleCardHeaderCentered : styles.moduleCardHeader}>
        {title && <h2 className={styles.cardTitle}>{title}</h2>}
        {!centerTitle && topRightContent}
      </div>
      {children}
    </Card>
  );
};
export default ModuleCard;
